import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ClientsPage } from '@/pages/ClientsPage';
import { ClientDetailPage } from '@/pages/ClientDetailPage';
import { AuditPage } from '@/pages/AuditPage';
import { ServersPage } from '@/pages/ServersPage';
import { UsersPage } from '@/pages/UsersPage';
import { AssignmentsPage } from '@/pages/AssignmentsPage';
import { AccountPage } from '@/pages/AccountPage';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminRoute } from '@/components/AdminRoute';
import { useBootstrapSession } from '@/hooks/useAuth';

export default function App() {
  const { isLoading } = useBootstrapSession();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-moss-300">
        <div className="animate-pulse text-sm tracking-wide">Cargando…</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/clientes" element={<ClientsPage />} />
        <Route path="/clientes/:server/:db" element={<ClientDetailPage />} />
        <Route path="/cuenta" element={<AccountPage />} />
        <Route element={<AdminRoute />}>
          <Route path="/auditoria" element={<AuditPage />} />
          <Route path="/servidores" element={<ServersPage />} />
          <Route path="/usuarios" element={<UsersPage />} />
          <Route path="/asignaciones" element={<AssignmentsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
